var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiamond11(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "diamond (1) 1",
    clipPath: "url(#clip0_1267_24821)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M41.6379 8.64648H26.25H10.8621L0.416411 19.9612L0 20.4138L26.25 53L52.5 20.4138L41.6379 8.64648Z",
    fill: "#24AE5F"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M26.2502 8.64648L18.1037 20.4138L10.8623 8.64648H26.2502Z",
    fill: "#1B8347"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M0.905215 20.4138H18.1035L20.5293 30.3707L21.4073 33.9914L26.25 53L0 20.4138",
    fill: "#1B8347"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M41.6379 8.64648L34.3965 20.4138L26.25 8.64648H41.6379Z",
    fill: "#1B8347"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M34.3966 20.4138H18.1035L26.25 8.64648L34.3966 20.4138Z",
    fill: "#4FBA6F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M52.5 20.4138L26.25 53L31.0927 33.9914L31.9707 30.3707L34.3965 20.4138H52.5Z",
    fill: "#1B8347"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M44.6481 41.5488L46.2168 44.8002L49.4681 46.3689L46.2168 47.9384L44.6481 51.1899L43.0785 47.9384L39.8271 46.3689L43.0785 44.8002L44.6481 41.5488Z",
    fill: "#F0C419"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M44.6487 43.3381L45.6344 45.383L47.6791 46.3687L45.6344 47.3553L44.6487 49.4001L43.6619 47.3553L41.6172 46.3687L43.6619 45.383L44.6487 43.3381Z",
    fill: "#F3D55B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M47.6794 0.5L49.249 3.75141L52.5004 5.32098L49.249 6.88962L47.6794 10.141L46.1108 6.88962L42.8594 5.32098L46.1108 3.75141L47.6794 0.5Z",
    fill: "#F0C419"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M47.6789 2.28955L48.6655 4.33438L50.7103 5.32102L48.6655 6.30672L47.6789 8.35145L46.6932 6.30672L44.6484 5.32102L46.6932 4.33438L47.6789 2.28955Z",
    fill: "#F3D55B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M4.82098 43.3589L6.38962 46.6103L9.64103 48.1789L6.38962 49.7485L4.82098 52.9999L3.25141 49.7485L0 48.1789L3.25141 46.6103L4.82098 43.3589Z",
    fill: "#F0C419"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M4.82053 45.1484L5.80624 47.1932L7.85097 48.1789L5.80624 49.1655L4.82053 51.2103L3.8339 49.1655L1.78906 48.1789L3.8339 47.1932L4.82053 45.1484Z",
    fill: "#F3D55B"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1267_24821"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52.5,
    height: 52.5,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamond11);
export default __webpack_public_path__ + "static/media/diamond (1) 1.6eeef223bb4c84c3e46882ea1850f4e4.svg";
export { ForwardRef as ReactComponent };